import { useRef, useState } from 'react'
import { PaymentCardInformation } from '@/src/app/main/(tabs)/card/card-management/_common/paymentCardInformation'
import { OptionItemSelector } from '@/src/app/main/(tabs)/card/card-management/payment/optionItemSelector'
import { DatePicker } from '@/src/common/components/DatePicker'
import type { DatePickerRef } from '@/src/common/components/DatePicker/DatePickerType'
import { formatDate } from '@/src/common/utils/date'
import { CardPaymentsE2E } from '@/src/experiences/card-payments/e2e'
import { Text } from 'react-native'
import { fontFamilies } from '@/src/common/theme/fonts'

export type DateType = 'Today' | 'Due Date' | 'Other Date'

export function DateSectionSection({
  dueDate,
  dateType,
  setDateType,
  date,
  setDate,
}: {
  dueDate: Date | undefined
  dateType: DateType
  setDateType: (dateType: DateType) => void
  date: Date | undefined
  setDate: (date: Date | undefined) => void
}) {
  const datePickerRef = useRef<DatePickerRef>({})
  const [otherDate, setOtherDate] = useState<Date | undefined>(() =>
    dateType === 'Other Date' ? date : undefined,
  )

  return (
    <PaymentCardInformation title="Date" containerStyle={{ marginHorizontal: 16 }}>
      <OptionItemSelector
        onItemPress={() => {
          setDateType('Today')
          setDate(new Date())
        }}
        label="Today"
        title={formatDate(new Date())}
        isSelected={dateType === 'Today'}
        testID={CardPaymentsE2E.Ids.Press.Today}
      />
      <OptionItemSelector
        onItemPress={
          dueDate
            ? () => {
                setDateType('Due Date')
                setDate(dueDate)
              }
            : undefined
        }
        label="Due Date"
        disabled={dueDate && dueDate < new Date()}
        title={dueDate ? formatDate(dueDate) : 'N/A'}
        isSelected={dateType === 'Due Date'}
      />
      <OptionItemSelector
        onItemPress={datePickerRef.current.open}
        label="Other Date"
        title={
          <>
            <Text
              style={{
                fontFamily: fontFamilies['PlusJakartaSans-Bold'],
                fontWeight: 700,
              }}
            >
              {otherDate ? formatDate(otherDate) : 'Select date'}
            </Text>
            {/* eslint-disable-next-line @typescript-eslint/no-deprecated */}
            <DatePicker
              date={otherDate}
              onDateChange={(newOtherDate) => {
                setOtherDate(newOtherDate)
                setDateType('Other Date')
                setDate(newOtherDate)
              }}
              ref={datePickerRef}
              inputProps={{
                containerStyle: { height: 0, overflow: 'hidden' },
                style: {
                  fontFamily: fontFamilies['PlusJakartaSans-Bold'],
                  fontWeight: 700,
                },
              }}
              minimumDate={new Date()}
              // 90 days into the future
              maximumDate={new Date(Date.now() + 90 * 24 * 60 * 60 * 1000)}
            />
          </>
        }
        titleStyle={otherDate ? undefined : { color: '#C1C4C6', fontWeight: '400' }}
        isSelected={dateType === 'Other Date'}
        withBorder={false}
      />
    </PaymentCardInformation>
  )
}
